import { render, staticRenderFns } from "./AccountDetailAdditionalInformationHeader.vue?vue&type=template&id=d76f8bec&scoped=true"
import script from "./AccountDetailAdditionalInformationHeader.vue?vue&type=script&lang=js"
export * from "./AccountDetailAdditionalInformationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76f8bec",
  null
  
)

export default component.exports